import { useState } from 'react';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import {
  selectFragmentName,
  selectFragment,
} from '../../lib/game-profile/fragments';
import { getEnvironment, isWaybetterProduct } from '../../lib/utils';
import { isProductMember } from '../../lib/membership';

const { FF_WBRT_2630_DISABLE_DIETBET_MEMBERSHIP_STATUS } = getEnvironment();

function statusQuery() {
  if (FF_WBRT_2630_DISABLE_DIETBET_MEMBERSHIP_STATUS === 'true') {
    return gql`
      query MembershipStatus {
        me {
          id
          isWaybetterMember
        }
      }
    `;
  }
  return gql`
    query MembershipStatus {
      me {
        id
        isWaybetterMember
        gameProfile(gameType: dietbet) {
          id
          ... on DietbetGameProfile {
            isActiveMember
          }
        }
      }
    }
  `;
}

function OPStatusQuery(gameType) {
  const fragment = selectFragment(gameType);

  return gql`
    query OPMembershipStatus($gameType: GameType!) {
      me {
        id
        gameProfile(gameType: $gameType) {
          id
          ...${selectFragmentName(gameType)}
        }
      }
    }
    ${fragment}
  `;
}

export function useMembershipStatusQuery(gameType, skip = false) {
  const [isCompleted, setCompleted] = useState(false);

  const query = isWaybetterProduct(gameType)
    ? statusQuery()
    : OPStatusQuery(gameType);

  const { data, error, loading } = useQuery(query, {
    fetchPolicy: 'network-only',
    skip,
    onCompleted: () => setCompleted(true),
    ssr: false,
    variables: { gameType },
  });

  if (loading) return { loading: true };
  if (error) return { error, loading };

  const isActiveWbMember = data?.me?.isWaybetterMember;
  const isActiveOpMember = data?.me?.gameProfile?.isActiveMember;
  const isActiveMemberForProduct = isProductMember({
    product: gameType,
    isActiveOpMember,
    isActiveWbMember,
  });

  return {
    isCompleted,
    isActiveMemberForProduct,
    loading,
  };
}
